// @flow
export const MyShortOffersBaseRoute: string = "/mein-remindme/angebote";

export const stromwechselUrl = "/strompreisvergleich";
export const gaswechselUrl = "/gaspreisvergleich";
